var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5157 74.3125C95.0446 74.3125 111.672 57.6851 111.672 37.1562C111.672 16.6274 95.0446 0 74.5157 0C53.9869 0 37.3595 16.6274 37.3595 37.1562C37.3595 57.6851 53.9869 74.3125 74.5157 74.3125ZM74.5157 18.5781C84.7337 18.5781 93.0939 26.9383 93.0939 37.1562C93.0939 47.3742 84.7337 55.7344 74.5157 55.7344C64.2978 55.7344 55.9376 47.3742 55.9376 37.1562C55.9376 26.9383 64.2978 18.5781 74.5157 18.5781ZM74.5157 92.8906C49.7139 92.8906 0.203247 105.338 0.203247 130.047V148.625H148.828V130.047C148.828 105.338 99.3175 92.8906 74.5157 92.8906ZM18.7814 130.047C20.825 123.359 49.5282 111.469 74.5157 111.469C99.5962 111.469 128.392 123.452 130.25 130.047H18.7814Z",
    fill: "#FF6BE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTeam);
export default __webpack_public_path__ + "static/media/MyTeam.bb9cd22ef68dcb63bc60db276ae2a05b.svg";
export { ForwardRef as ReactComponent };